import { type ListingPrice, type ListingPriceClassification } from '@kijiji/generated/graphql-types'

import { isAutosDealerAmountPrice } from '@/types/search'

export const getPriceClassification = (
  price?: ListingPrice | null
): ListingPriceClassification | undefined | null => {
  return isAutosDealerAmountPrice(price) ? price.classification : undefined
}
